import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import * as dayjs from 'dayjs';

@Component({
  selector: 'egi-daterange-picker',
  templateUrl: './egi-daterange-picker.component.html',
  styleUrls: ['./egi-daterange-picker.component.scss'],
})
export class EgiDaterangePickerComponent {
  @Input() value: { start_date: moment.Moment; end_date: moment.Moment };
  @Output() valueChange = new EventEmitter<any>();

  @Input() placeholder: string = 'Select date range';
  @Input() showRangeLabelOnInput: boolean = true;
  @Input() showCustomRangeLabel: boolean = true;
  @Input() singleDatePicker: boolean = false;
  @Input() disabled: boolean = false;
  @Input() minDate: moment.Moment = moment().subtract(1, 'year');
  @Input() opens: 'left' | 'right' | 'center' = 'right';

  @Input() ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
    'Last 7 Days': [moment().subtract(6, 'day'), moment()],
    'Last 30 Days': [moment().subtract(29, 'day'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
  };

  onDatesUpdated(event: any): void {
    // console.log('getDateRangeSelected', event);
    // console.log('getDateRangeSelected', this.value);
    if (event.startDate !== null && event.endDate !== null) {
      this.value.start_date = moment.isMoment(event.startDate)
        ? event.startDate
        : moment(dayjs(event.startDate).format('YYYY-MM-DD'));
      this.value.end_date = moment.isMoment(event.endDate)
        ? event.endDate
        : moment(dayjs(event.endDate).format('YYYY-MM-DD'));
    }
    this.valueChange.emit(this.value);
  }
}
